import React from "react";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";

import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import "./styles.css"; // Must include updated CSS

import { CBadge, CSidebarNav } from "@coreui/react";
import { useSelector } from "react-redux";
import { getSellerAccess } from "../../utils/getSellerRedirect";

export const AppSidebarNav = ({ items }) => {
  const user = useSelector((state) => state.auth.user);
  const accountStatus = useSelector((state) => state.seller.accountStatus.data);

  if (!user) {
    return null; // or a loading skeleton
  }

  const { allowedRoutes } = getSellerAccess(user, accountStatus);

  const filteredItems = items.filter((item) => {
    if (!allowedRoutes) return true;
    return allowedRoutes.includes(item.to);
  });

  const navLink = (name, icon, badge, indent = false) => (
    <>
      {icon
        ? icon
        : indent && (
          <span className="nav-icon">
            <span className="nav-icon-bullet"></span>
          </span>
        )}
      {name}
      {badge && (
        <CBadge color={badge.color} className="ms-auto" size="sm">
          {badge.text}
        </CBadge>
      )}
    </>
  );

  const navItem = (item, index, indent = false) => {
    const { component, name, badge, icon, ...rest } = item;
    const Component = component;
    const content = navLink(name, icon, badge, indent);

    return (
      <Component as="div" key={index}>
        {rest.to ? (
          <NavLink to={rest.to} className="nav-link">
            {content}
          </NavLink>
        ) : rest.href ? (
          <a
            href={rest.href}
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link"
          >
            {content}
          </a>
        ) : (
          <div className="nav-link disabled-tab">{content}</div>
        )}
      </Component>
    );
  };

  const navGroup = (item, index) => {
    const { component, name, icon, items, ...rest } = item;
    const Component = component;

    return (
      <Component
        compact
        as="div"
        key={index}
        toggler={navLink(name, icon)}
        {...rest}
      >
        {items?.map((item, idx) =>
          item.items ? navGroup(item, idx) : navItem(item, idx, true)
        )}
      </Component>
    );
  };

  return (
    <CSidebarNav as={SimpleBar}>
      {items &&
        items.map((item, index) =>
          item.items ? navGroup(item, index) : navItem(item, index)
        )}
    </CSidebarNav>
  );
};

AppSidebarNav.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
};
